import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { IComponent } from '../../interfaces';

// services
import * as srv from '../../services';

@Component({
  selector: 'app-level',
  templateUrl: './level.component.html',
  styleUrls: ['./level.component.scss']
})
export class LevelComponent implements IComponent, OnInit, OnChanges {
  // implement icomponent
  name = 'LevelComponent';
  subscriptions: Subscription[] = [];

  // implement local
  @Input() LEVEL: number;
  @Input() LEVELTEXT: string;
  @Input() CHECKED: Boolean;
  @Input() DISABLED: Boolean;

  @Output() Click = new EventEmitter<number>(true);
  @Input() COLOR: string;
  class = 'level';

  constructor(
    private _logSrv: srv.LogService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.LEVEL) {
      this._logSrv.Debug(this.name, [this.LEVEL]);
      switch (+this.LEVEL) {
        case 1:
          this.class = 'level level1';
          break;
        case 2:
          this.class = 'level level2';
          break;
        case 3:
          this.class = 'level level3';
          break;
      }

    }
  }

  OnCheckBoxClick() {
    this.CHECKED = true;
    this.Click.emit(this.LEVEL);
  }

}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/level/level.component.ts